import { Component } from 'preact'
import { ColorResult, SketchPicker } from 'react-color'
import GlobalClick from '../interactive/documentClick'
import tinycolor from 'tinycolor2'
import { isChangeEvent } from '../../libs/typeGuards'

interface Props {
  color: string | null
  colorKey?: string
  disabled: boolean
  isColorSelectorEnabled: boolean
  updateColor: (color: string) => void
  disableColorSelector: () => void
  setColorSelector: () => void
  disableAlpha?: boolean
  presetColors?: string[]
  position?: 'top' | 'bottom'
}

export default class ColorPicker extends Component<Props> {
  constructor (props: Props) {
    super(props)

    this.updateColors = this.updateColors.bind(this)
  }

  updateColors (color: ColorResult | string) {
    let newHexColor: string

    if (typeof color !== 'string') {
      newHexColor = tinycolor(color.rgb).toHex8String()
    } else {
      newHexColor = color
    }

    if (newHexColor.length === 9 && newHexColor.substring(7) === 'ff') {
      newHexColor = newHexColor.substring(0, 7)
    }
    const isHexValid = /^#([0-9A-F]{3}|[0-9A-F]{6}|[0-9A-F]{8})$/i.test(newHexColor)

    if (!isHexValid) {
      return
    }

    this.props.updateColor(newHexColor)
  }

  render ({ color, disabled, disableColorSelector, setColorSelector, presetColors, isColorSelectorEnabled, disableAlpha, position = 'bottom' }: Props) {
    if (color && color.length === 9 && color.substring(7) === 'ff') {
      color = color.substring(0, 7)
    }
    return (
      <GlobalClick onGlobalClick={disableColorSelector}>
        <div className={`theme-configuration--color-selector color-selector-wrapper ${disabled ? 'disabled' : ''}`}>
          <div className='theme-configuration--color-visual color-visual' onClick={setColorSelector}>
            <div style={{ backgroundColor: color }} className='color-preview' />
            <input
              class='color-input'
              title=''
              type='text'
              onKeyUp={(e) => { if (isChangeEvent(e)) { this.updateColors(e.target.value) } }}
              value={color || ''}
            />
          </div>
          <div className={`theme-configuration--color-selector color-selector theme-configuration--color-selector-${position}`}>
            {
              isColorSelectorEnabled
                ? (
                  <SketchPicker
                    disableAlpha={!!disableAlpha}
                    color={color || ''}
                    presetColors={presetColors || []}
                    onChangeComplete={(color) => this.updateColors(color)}
                  />)
                : null
            }
          </div>
        </div>
      </GlobalClick>
    )
  }
}
